import { ApiClientImplementation } from 'infra/api-client/api-client'

import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'

import { DocumentRepositoryImpl } from 'repository/repositories/document/document-repository-impl'
import DocumentService from 'presentation/contexts/services/document-service'
import { RemoteDeleteDoctorDocument } from 'service/usecases/delete-doctor-document/remote-delete-doctor-document'
import { PrepareApiRequestAwsDocumentDecorator } from 'main/decorators/prepare-api-request-aws-document-decorator/prepare-api-request-aws-document-decorator'
import { RemoteGenerateAwsPresignedUrlDocument } from 'service/usecases/generate-aws-presigned-url-document/remote-generate-aws-presigned-url-document'
import { AwsDocumentRepository } from 'repository/repositories/aws-document/aws-document-repository'
import { RemoteUploadDocumentAws } from 'service/usecases/upload-document-aws/remote-upload-document-aws'
import { RemoteProcessDocumentAws } from 'service/usecases/process-document-aws/remote-process-document-aws'

export default function makeDocumentService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )
  const documentRepository = new DocumentRepositoryImpl(apiRepository)

  // AWS DOCUMENT API (TODO: Separate this into a new service)
  const apiAwsDocumentRepository = new PrepareApiRequestAwsDocumentDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )
  const awsDocumentRepository = new AwsDocumentRepository(
    apiAwsDocumentRepository
  )

  const deleteDoctorDocument = new RemoteDeleteDoctorDocument(
    documentRepository
  )

  const generateAwsPresignedUrlDocument =
    new RemoteGenerateAwsPresignedUrlDocument(awsDocumentRepository)

  const uploadDocumentAws = new RemoteUploadDocumentAws(awsDocumentRepository)

  const processDocumentAws = new RemoteProcessDocumentAws(awsDocumentRepository)

  return new DocumentService({
    deleteDoctorDocument,
    generateAwsPresignedUrlDocument,
    uploadDocumentAws,
    processDocumentAws
  })
}
